import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "../ErrorMessage/errorMessage";
import * as S from "../../cmsForm.style";
export var CustomInput = function(_param) {
    var name = _param.name, label = _param.label, isHidden = _param.isHidden, isColMiddle = _param.isColMiddle, isDisabled = _param.isDisabled, isPendingRequest = _param.isPendingRequest, props = _object_without_properties(_param, [
        "name",
        "label",
        "isHidden",
        "isColMiddle",
        "isDisabled",
        "isPendingRequest"
    ]);
    var ref;
    var ref1 = useFormContext(), register = ref1.register, errors = ref1.formState.errors;
    var error = (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message;
    var id = "".concat(name, "-").concat(props.type, "-").concat(label);
    return /*#__PURE__*/ _jsxs(S.StyledInputContainer, {
        isColMiddle: isColMiddle,
        isHidden: isHidden,
        children: [
            /*#__PURE__*/ _jsxs(S.StyledFieldset, {
                isDisabled: isDisabled,
                isError: !!error,
                children: [
                    /*#__PURE__*/ _jsx(S.StyledInput, _object_spread_props(_object_spread({}, register(name), props), {
                        id: id,
                        placeholder: " ",
                        disabled: isDisabled || isPendingRequest
                    })),
                    label && /*#__PURE__*/ _jsx(S.StyledLegend, {
                        htmlFor: id,
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(ErrorMessage, {
                    error: error
                })
            })
        ]
    });
};
